import { render, staticRenderFns } from "./CategoriasSlider.vue?vue&type=template&id=312559d4&scoped=true"
import script from "./CategoriasSlider.vue?vue&type=script&lang=js"
export * from "./CategoriasSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoriasSlider.vue?vue&type=style&index=0&id=312559d4&prod&lang=scss"
import style1 from "./CategoriasSlider.vue?vue&type=style&index=1&id=312559d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312559d4",
  null
  
)

export default component.exports